import React from "react";
import style from "./index.module.scss";
import { Table } from "antd";
import {
    filteredStuListAtom,
    useAddTag,
    useRemoveTag
} from "service/stores/RollCallStore";
import { useAtomValue } from "jotai";
import { MarkItem, RollCallItem } from "service/rollCall";
import InputTag from "../InputTag";
import CustomTag from "../CustomTag";

export default function StuTable() {
    const stuList = useAtomValue(filteredStuListAtom);
    const addTag = useAddTag();
    const removeTag = useRemoveTag();

    // 学生信息
    function renderStudent(text: string, item: RollCallItem) {
        return (
            <div className={style.student}>
                <span className={style.stuName} title={text}>
                    {text}
                </span>

                <span className={style.stuNo}>{item.studentNo}</span>
            </div>
        );
    }

    function renderTags(tags: MarkItem[]) {
        return (
            <div>
                {tags.map(item => (
                    <CustomTag key={item.id} onClose={() => removeTag(item.id)}>
                        {item.mark}
                    </CustomTag>
                ))}
            </div>
        );
    }

    function renderInput(tag: any, item: RollCallItem) {
        return <InputTag onSubmit={text => addTag(item.studentNo, text)} />;
    }

    return (
        <div className={style.root}>
            <Table
                dataSource={stuList}
                rowKey="studentId"
                pagination={false}
                scroll={{ y: "calc(100vh - 300px)" }}>
                <Table.Column
                    title="序号"
                    dataIndex="studentId"
                    width={100}
                    align="center"
                    render={(text, data, index) => index + 1}
                />
                <Table.Column
                    title="学生信息"
                    dataIndex="name"
                    width={200}
                    render={renderStudent}
                />
                <Table.Column
                    title=""
                    dataIndex="markList"
                    align="right"
                    render={renderTags}
                />
                <Table.Column
                    title="操作"
                    width={150}
                    align="center"
                    render={renderInput}
                />
            </Table>
        </div>
    );
}
